module.exports = __webpack_public_path__ + "img/Banner-Graphics.9555d9a6.png";